import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import {
  Card,
  CardContent,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Typography,
  IconButton,
  Button
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  dialogBox: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '7px'
  },
  closeButton: {
    color: theme.palette.warning.main
  },
  dialogActions: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingLeft: '25px',
    paddingRight: '25px',
    paddingTop: '13px',
    paddingBottom: '20px'
  }
}));

export default function InputModal(props) {
  const classes = useStyles();
  const {
    isOpen,
    setIsOpen,
    title,
    size,
    message,
    color,
    variant,
    formValues,
    inputModalbuttons
  } = props;

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <div>
      <Dialog
        maxWidth={size || 'xs'}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={isOpen}>
        <div className={classes.dialogBox}>
          <DialogTitle id="customized-dialog-title" onClose={handleClose}>
            <Typography variant="h2">{title}</Typography>
          </DialogTitle>
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </div>
        <DialogContent>
          <Card>
            <CardContent>{message}</CardContent>
          </Card>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          {inputModalbuttons.length > 0 &&
            inputModalbuttons.map(button => {
              return (
                <Button
                  key={button.name}
                  color={color || 'primary'}
                  variant={variant || 'contained'}
                  onClick={(event) => button.action(event, formValues)}>
                  {button.name}
                </Button>
              );
            })}
        </DialogActions>
      </Dialog>
    </div>
  );
}
